import styled from "styled-components";
import { contentMobileQuery } from "../constants/breakpoints";

export const CtaButtonRow = styled.div<{
  $centerFromTablet?: boolean;
  $center?: boolean;
}>`
  display: flex;
  flex-wrap: wrap;
  gap: 1.6rem;
  margin-top: 3.2rem;
  ${({ $center }) => $center && `justify-content: center;`}

  ${({ $centerFromTablet }) =>
    $centerFromTablet &&
    `
    @media only screen and (max-width: 1000px) {
      justify-content: center;
    }
  `}

  ${contentMobileQuery} {
    width: 100%;
    gap: 1.1rem;
  }
`;

export const CtaPrimaryButton = styled.button<{ $minWidth?: string }>`
  font-family: "Space Grotesk", sans-serif;
  font-weight: 700;
  font-size: 1.5rem;
  padding: 1.4rem 2.8rem;
  min-width: ${({ $minWidth }) => $minWidth ?? "18rem"};
  border: none;
  border-radius: 999px;
  cursor: pointer;
  background: var(--primary);
  color: var(--white, #fff);
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(255, 0, 102, 0.35);
  }

  ${contentMobileQuery} {
    width: 100%;
    min-width: 0;
  }
`;

export const CtaGhostButton = styled.button<{ $minWidth?: string }>`
  font-family: "Space Grotesk", sans-serif;
  font-weight: 700;
  font-size: 1.5rem;
  padding: 1.4rem 2.8rem;
  min-width: ${({ $minWidth }) => $minWidth ?? "18rem"};
  border-radius: 999px;
  cursor: pointer;
  background: transparent;
  color: var(--primary);
  border: 2px solid var(--primary);
  transition: transform 0.2s, background 0.2s;

  &:hover {
    transform: translateY(-2px);
    background: rgba(255, 0, 102, 0.06);
  }

  ${contentMobileQuery} {
    width: 100%;
    min-width: 0;
  }
`;
